import script from "./OpenButtonGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpenButtonGroup.vue?vue&type=script&setup=true&lang=ts"

import "./OpenButtonGroup.vue?vue&type=style&index=0&id=01146bb1&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01146bb1"]])

export default __exports__